module.exports = __webpack_public_path__ + "static/media/Flaticon.b07f14e8.svg";